import imgEstudos from "../../assets/img/estudos.svg";
import imgGestao from "../../assets/img/gestao.svg";
import imgProjetos from "../../assets/img/projetos.svg";
import imgCapacitacao from "../../assets/img/capacitacao.svg";
import imgSeguranca from "../../assets/img/seguranca.svg";
import imgEsg from "../../assets/img/esg.png";
import "./Servicos.css";
import { Link } from "react-router-dom";

function Servicos() {
  return (
    <section className="py-5 bg-branco" id="servicos">
      <div className="container servicos">
        <div className="text-center mb-5 scroll-reveal-zoom">
          <h2 className="titulo-secao">
            Nossos Serviços
            <span className="barra"></span>
          </h2>
          <p>
            Consultoria de engenharia abrangente, adaptada à gestão ambiental.
          </p>
        </div>

        <div className="row g-4 d-flex justify-content-center">
          {/* Card 1 */}
           <div className="col-12 col-md-6 col-lg-4 scroll-reveal-zoom">
            <div className="card h-100 card-servico">
              <img
                src={imgCapacitacao}
                alt="Capacitação e Treinamento"
                className="card-img-top"
              />
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <h5 className="card-title">Capacitação e Treinamento</h5>
                  <p className="card-text">
                    Promoção de palestras e workshops que capacitam clientes e
                    parceiros, garantindo uma melhor aplicação das práticas
                    ambientais e de segurança.
                  </p>
                </div>
                <div className="mt-3">
                  <Link to="/servicos/capacitacao-e-treinamento-ambiental" className="btn-saiba-mais">
                    Saiba mais →
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-12 col-md-6 col-lg-4 scroll-reveal-zoom">
            <div className="card h-100 card-servico">
              <img
                src={imgEstudos}
                alt="Estudos e Regularização"
                className="card-img-top"
              />
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <h5 className="card-title">Estudos e Regularização</h5>
                  <p className="card-text">
                    Elaboração de estudos ambientais detalhados e gestão
                    completa dos processos de regularização assegurando
                    conformidade com as normas vigentes.
                  </p>
                </div>
                <div className="mt-3">
                  <Link to="/servicos/estudos-e-regularizacao-ambiental" className="btn-saiba-mais">
                    Saiba mais →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        

          {/* Card 3 */}
            <div className="col-12 col-md-6 col-lg-4 scroll-reveal-zoom">
            <div className="card h-100 card-servico">
              <img
                src={imgEsg}
                alt="Gestão Estratégica em ESG"
                className="card-img-top"
              />
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <h5 className="card-title">Gestão Estratégica em ESG</h5>
                  <p className="card-text">
                    Desenvolvimento e implementação de estratégias de ESG (Meio Ambiente, Sociedade e Governança) para empresas que desejam alinhar seus objetivos com práticas sustentáveis e responsáveis.
                  </p>
                </div>
                <div className="mt-3">
                  <Link to="/servicos/gestao-estrategica-em-esg" className="btn-saiba-mais">
                    Saiba mais →
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Card 4 */}
           <div className="col-12 col-md-6 col-lg-4 scroll-reveal-zoom">
            <div className="card h-100 card-servico">
              <img
                src={imgGestao}
                alt="Gestão e Monitoramento"
                className="card-img-top"
              />
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <h5 className="card-title">Gestão e Monitoramento</h5>
                  <p className="card-text">
                    Implementação de sistemas de monitoramento e geotécnico que
                    permitem a análise contínua e a manutenção da integridade
                    dos processos.
                  </p>
                </div>
                <div className="mt-3">
                  <Link to="/servicos/consultoria-monitoramento-e-gestao-ambiental" className="btn-saiba-mais">
                    Saiba mais →
                  </Link>
                </div>
              </div>
            </div>
          </div>
          

          {/* Card 5 */}
          <div className="col-12 col-md-6 col-lg-4 scroll-reveal-zoom">
            <div className="card h-100 card-servico">
              <img
                src={imgProjetos}
                alt="Projetos de Engenharia"
                className="card-img-top"
              />
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <h5 className="card-title">Projetos de Engenharia</h5>
                  <p className="card-text">
                    Desenvolvimento e execução de projetos para sistemas de
                    controle ambiental geotécnico e de saneamento, adaptados
                    para qualquer empreendimento.
                  </p>
                </div>
                <div className="mt-3">
                  <Link to="/servicos/engenharia-aplicada-e-projetos-tecnicos" className="btn-saiba-mais">
                    Saiba mais →
                  </Link>
                </div>
              </div>
            </div>
          </div>
          
          {/* Card 6 */}
        <div className="col-12 col-md-6 col-lg-4 scroll-reveal-zoom">
            <div className="card h-100 card-servico">
              <img
                src={imgSeguranca}
                alt="Segurança do Trabalho"
                className="card-img-top"
              />
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <h5 className="card-title">Segurança do Trabalho</h5>
                  <p className="card-text">
                    Gerenciamento de processos de segurança do trabalho
                    incluindo a realização de auditorias e perícias para
                    identificar e mitigar riscos.
                  </p>
                </div>
                <div className="mt-3">
                  <Link to="/servicos/seguranca-do-trabalho" className="btn-saiba-mais">
                    Saiba mais →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Servicos;
